import React from 'react';
import "./aboutme.css";
import "./responsive.css";
import Page from "../../Utilities/Page";
import Abilities from './SkillSection/Abilities';
import Education from './Education';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { BsLinkedin } from "react-icons/bs";
import { SiHackthebox } from "react-icons/si";
import { GiCornerFlag } from "react-icons/gi";
import Certification from './Certification';
import CVE from './CVE';

const AboutMe = () => {
  return (
    <Page cls='about' title='Chai Cheng Xun | Personal Portfolio' >
      <section className="hero">
        <div className="inner page-wrap">
          <div className="intro fss">
            <div className="shell">
              <span className="user">visitor@chaichengxun</span>:~$ whoami<span className="caret"></span>
            </div>
            <h1 className="name d-title">Chai Cheng Xun</h1>
            {/* the previous tagline, kept so it is a one line restore:
                <div className="role">加油努力，大便要用力，大不出来没关系，至少放个屁</div> */}
            <div className="role">Penetration Tester</div>
            <p className="bio">
              加油努力，大便要用力，大不出来没关系，至少放个屁
            </p>
            <div className="actions fcs">
              <Link className="action solid fcc" to="/cve">View research</Link>
              <Link className="action fcc" to="/projects">Projects</Link>
              <div className="socials fcc">
                <a href="https://app.hackthebox.com/profile/1666286" target="_blank" rel="noopener noreferrer" title="HackTheBox" aria-label="HackTheBox"><SiHackthebox /></a>
                <a href="https://www.linkedin.com/in/chai-cheng-xun" target="_blank" rel="noopener noreferrer" title="LinkedIn" aria-label="LinkedIn"><BsLinkedin /></a>
                <a href="https://qiaonpc.github.io/" target="_blank" rel="noopener noreferrer" title="Blog" aria-label="Blog"><GiCornerFlag /></a>
              </div>
            </div>
          </div>
          <div className="avatar">
            <LazyLoadImage effect='blur' src="https://res.cloudinary.com/dur07sfvb/image/upload/v1704616799/IMG_2499_u987xp.jpg" alt="Chai Cheng Xun" />
          </div>
        </div>
      </section>
      <Abilities />
      <CVE limit={5} showMore />
      <Certification limit={5} showMore />
      <Education />
    </Page>
  )
}

export default AboutMe
